export function isPortraitOrientation() {
  const {innerWidth: width, innerHeight: height} = window;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
  const isPortraitMode = height > width;

  return isPortraitMode && isMobile ? true : false;
}
